import React, {useState,useRef} from 'react'
import Player from './components/Player'
import Song from './components/Song'
import './styles/app.scss';
import data from './data';
import Library from './components/Library';
import Nav from './components/Nav';

function App() {
  //Ref 取得audio的資訊
  const audioRef = useRef(null)
  //State
  const [songs,setSongs] = useState(data()); //取得所有歌曲
  const [currentSong,setCurrentSong] = useState(songs[0])
  const [isPlaying, setIsPlaying] = useState(false)
  const [songInfo,setSongInfo] = useState({
    currentTime: 0,
    duration: 0,
    animationPercentage: 0
  });

  const [libraryStatus,setLibraryStatus] = useState(false);

  const timeUpdateHandler = (e) => {
    const current = e.target.currentTime;
    const duration = e.target.duration;
    //計算歌曲播放長度
    const roundeCurrent = Math.round(current);
    const roundeDuration = Math.round(duration);
    const animation = Math.round((roundeCurrent / roundeDuration) * 100)

    setSongInfo({...songInfo,currentTime: current, duration, animationPercentage:animation})
  };

  //自動播放
  const songEndHandler = async () => {
    let currentIndex = songs.findIndex((song) => song.id === currentSong.id);
    await setCurrentSong(songs[currentIndex + 1] || songs[0]);
    if(isPlaying) audioRef.current.play()
  }
  return (
    <div className={`App ${libraryStatus ? "library-active" : ""}`}>
      <Nav
      libraryStatus={libraryStatus}
      setLibraryStatus={setLibraryStatus}
      />
      <Song currentSong={currentSong} isPlaying={isPlaying}/>
      <Player 
      audioRef={audioRef}
      setIsPlaying={setIsPlaying} 
      isPlaying={isPlaying} 
      currentSong={currentSong} 
      setSongInfo={setSongInfo}
      songInfo={songInfo}
      songs={songs}
      setCurrentSong={setCurrentSong}
      setSongs={setSongs}
      />
      <Library 
      audioRef={audioRef}
      songs={songs} 
      setCurrentSong={setCurrentSong}
      isPlaying={isPlaying}
      setSongs={setSongs}
      libraryStatus={libraryStatus}
      />
      <audio 
      onTimeUpdate={timeUpdateHandler} 
      onLoadedMetadata={timeUpdateHandler} 
      ref={audioRef} src={currentSong.audio}
      onEnded={songEndHandler}
      ></audio>
    </div>
  );
}

export default App;
